import React from 'react';
import { Button, Modal, ButtonToolbar, Col, Row } from 'react-bootstrap';
import moment from 'moment';
import { DATE_FORMAT, FIELD_STARTDATE, FIELD_ENDDATE, REGEX_DATE, MIN_DB_DATE_EXACT, MAX_DB_DATE_EXACT } from '../../../utils/constants';
import JapaneseDatePicker from '../../components/JapaneseDatePicker';
import ErrorAlert from '../../components/ErrorAlert';

const ProposalModal = (props) => {

    let formatStartDate = moment(props.startDate, DATE_FORMAT);
    let startDateValue = (props.startDate.toString()).match(REGEX_DATE) && formatStartDate.isValid() && !(MIN_DB_DATE_EXACT === props.startDate.toString()) ? formatStartDate : null;
    let formatEndDate = moment(props.endDate, DATE_FORMAT);
    let endDateValue = (props.endDate.toString()).match(REGEX_DATE) && formatEndDate.isValid() && !(MAX_DB_DATE_EXACT === props.endDate.toString()) ? formatEndDate : null;

    return (
        <Modal show={props.showModal} onHide={props.toggleModal}>

            <Modal.Header closeButton>
                <Modal.Title>{props.title}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Row className="modal-row">

                    <ErrorAlert errors={props.error} className="mr-25"/>

                    <Col sm={3} className={"modal-label"}>提案期間</Col>

                    <Col sm={9} className="modal-row-field">

                        <Col sm={5} className="modal-field">
                            <JapaneseDatePicker
                                bordered={true}
                                onChangeRaw={props.handleDateChangeRaw}
                                name={FIELD_STARTDATE}
                                selected={startDateValue}
                                className="modal-datepicker"
                                onChange={props.handleDateChange.bind(this, FIELD_STARTDATE, DATE_FORMAT)}
                            />
                        </Col>

                        <Col sm={2} className="modal-separator">〜</Col>

                        <Col sm={5} className="modal-field">
                            <JapaneseDatePicker
                                bordered={true}
                                onChangeRaw={props.handleDateChangeRaw}
                                name={FIELD_ENDDATE}
                                selected={endDateValue}
                                className="modal-datepicker"
                                onChange={props.handleDateChange.bind(this, FIELD_ENDDATE, DATE_FORMAT)}
                            />
                        </Col>

                    </Col>

                </Row>

                <Row>
                    <ButtonToolbar className="modal-field">
                        <Button
                            className="button-common"
                            onClick={props.handleSubmit}
                            disabled={!props.isChecked}
                        >
                            一括登録
                        </Button>

                        <Button
                            className="button-common"
                            onClick={props.toggleModal}
                        >
                            キャンセル
                        </Button>
                    </ButtonToolbar>
                </Row>
            </Modal.Body>
        </Modal>
    );
}

export default ProposalModal;